import { render, staticRenderFns } from "./matriz-riesgos-editar.vue?vue&type=template&id=bf53b248&"
import script from "./matriz-riesgos-editar.vue?vue&type=script&lang=js&"
export * from "./matriz-riesgos-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports